import { ActionType } from './actions';
import { initialState, IState } from './state';

export const reducer = (state: IState = initialState, { type, payload }: { type: ActionType; payload?: any }): IState => {
  switch (type) {
    case ActionType.FETCH_WFM_EXPANDED_WORKERS_ONSITE_SUCCESS:
      return { ...state, wfmExpanded: { ...((state?.wfmExpanded || {}) as any), workers: payload.workers } };
    case ActionType.FETCH_WFM_EXPANDED_COMPANIES_ONSITE_SUCCESS:
      return { ...state, wfmExpanded: { ...((state?.wfmExpanded || {}) as any), companies: payload.companies } };
    case ActionType.FETCH_WFM_EXPANDED_WORKERS_FOR_COMPANY_ONSITE_SUCCESS:
      return { ...state, wfmExpanded: { ...((state?.wfmExpanded || {}) as any), workersForCompany: payload.workers } };
    case ActionType.FETCH_WFM_EXPANDED_TRADES_ONSITE_SUCCESS:
      return { ...state, wfmExpanded: { ...((state?.wfmExpanded || {}) as any), trades: payload.trades } };
    case ActionType.FETCH_WFM_EXPANDED_WORKERS_FOR_TRADE_ONSITE_SUCCESS:
      return { ...state, wfmExpanded: { ...((state?.wfmExpanded || {}) as any), workersForTrade: payload.workers } };
    case ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_TRADES_SUCCESS:
      return { ...state, dailyLogExpanded: { ...((state?.dailyLogExpanded || {}) as any), trades: payload.trades } };
    case ActionType.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_TRADE_SUCCESS:
      return { ...state, dailyLogExpanded: { ...((state?.dailyLogExpanded || {}) as any), workersForTrade: payload.workers } };
    case ActionType.FETCH_DAILY_LOG_EXPANDED_NEW_WORKERS_BADGED_SUCCESS:
      return { ...state, dailyLogExpanded: { ...((state?.dailyLogExpanded || {}) as any), newWorkersBadged: payload.workers } };
    case ActionType.FETCH_DAILY_LOG_EXPANDED_NEW_COMPANIES_ENROLLED_SUCCESS:
      return { ...state, dailyLogExpanded: { ...((state?.dailyLogExpanded || {}) as any), newCompaniesEnrolled: payload.companies } };
    case ActionType.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_NEW_COMPANY_SUCCESS:
      return { ...state, dailyLogExpanded: { ...((state?.dailyLogExpanded || {}) as any), workersForNewCompany: payload.workers } };
    case ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_HEADCOUNT_SUCCESS:
      return { ...state, dailyLogExpanded: { ...((state?.dailyLogExpanded || {}) as any), totalHeadcount: payload.workers } };
    case ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_COMPANIES_SUCCESS:
      return { ...state, dailyLogExpanded: { ...((state?.dailyLogExpanded || {}) as any), totalCompanies: payload.companies } };
    case ActionType.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_COMPANY_SUCCESS:
      return { ...state, dailyLogExpanded: { ...((state?.dailyLogExpanded || {}) as any), workersForTotalCompany: payload.workers } };
    case ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_ONSITE_HOURS_SUCCESS:
      return { ...state, dailyLogExpanded: { ...((state?.dailyLogExpanded || {}) as any), totalOnsiteHours: payload.workers } };
    case ActionType.FETCH_IN_PROGRESS_WIDGET_EXPORTS_SUCCESS:
      return { ...state, inProgressExports: payload.inProgressExports };
    default:
      return state;
  }
};
